// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KFVh","selected":"styles_selected__24VQ7"};